<template>
  <v-app id="app">
      <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: "App",

  metaInfo() {
    return {
      title: this.$i18n.t("meta.app.title"),
    };
  },

  components: {},

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
@import "@/sass/main.scss";
</style>
